/* eslint-disable jsx-a11y/anchor-is-valid */
import './style.scss';

import { isEmptyOrNull } from 'app/utils/helpers/extendMethod';
import { Formik, FormikHelpers } from 'formik';
import React, { useEffect, useRef, useState } from 'react';
import { Col, Modal, Row } from 'react-bootstrap-v5';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { Response } from '../../../../../setup/axios/HttpResponse';
import { HTTP_RESPONSE_STATUS } from '../../../../../setup/constants/Http';
import { ToastDefaultConfig } from '../../../../../setup/toast/ToastConfig';
import { StepperComponent } from '../../../../../theme/assets/ts/components';
import { USER_TYPE } from '../../../../utils/common/constants';
import { SelectFilter, ServiceTreeNode } from '../../../../utils/common/models';
import { convertOperationObjectToList } from '../../../../utils/helpers';
import { UserSchemasHelper } from '../../../../utils/helpers/UserValidate';
import { checkValidPhoneNumber } from '../../../../utils/services/userService';
import { ServiceScopeModel } from '../../../auth/models/AuthModel';
import {
    AdminResponse,
    BusNotLinkedDriver,
    CheckStepAccountInfo,
    City,
    DispatchCenter,
    Driver,
    LinkedDispatcher,
    Nationality,
    Skill,
    SPInfos,
    Team,
    UserFormModel,
    UserModel
} from '../../models';
import { Housing } from '../../models/Nationality';
import { OperationHoursAndMap } from '../../models/OperationHoursAndMap';
import { userApi } from '../../redux/UserApi';
import AccountInfo from '../create-user/step/account-info/AccountInfo';
import { StepByStepTechUserHeader } from '../create-user/step/step-by-step-header/StepByStepTechUserHeader';
import WorkInfo from '../create-user/step/work-info/WorkInfo';
import WorkLocation from '../create-user/step/work-location/WorkLocation';
import { Completed } from './steps/Completed';
import { Province } from '../../../customers/models';

type Props = {
    className?: string,
    workerId?: string | null,
    nationalities: Nationality[],
    skills: Skill[];
    services?: ServiceScopeModel;
    listAdmin: AdminResponse[];
    busesNotLinkedDriver: BusNotLinkedDriver[];
    dispatchCenters: DispatchCenter[];
    drivers: Driver[];
    linkedDispatchers: LinkedDispatcher[];
    operationHoursAndMap: OperationHoursAndMap[];
    teams: Team[];
    cities: City[];
    housings: Housing[];
    onHide?: () => void,
    onUpdated?: (data: UserModel) => void,
    rtlMode: boolean,
}

type IForm = {
    pricePerMonth?: number | string
} & UserFormModel;
const checkExistEmail = async (id: any, email: any) => {
    const params = {
        email: email,
        userId: id
    }

    const response: Response<boolean> = await userApi.checkExistEmail(params);

    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
        return response.data;
    } else {
        toast.error(response.message, ToastDefaultConfig());
        return false;
    }
}
const checkExistPhone = async (id: any, phone: any) => {
    const params = {
        phoneNumber: phone,
        userId: id
    }

    const response: Response<boolean> = await userApi.checkExistPhone(params);

    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
        return response.data;
    } else {
        toast.error(response.message, ToastDefaultConfig());
        return false;
    }
}
const checkExistUserInfo = async (id: any, phone: any, email: any) => {
    const params: CheckStepAccountInfo = {
        workerId: '',
        phoneNumber: phone,
        email: email,
        userId: id
    }

    const response: Response<boolean> = await userApi.checkExistUserInfo(params);

    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
        return response.data;
    } else {
        toast.error(response.message, ToastDefaultConfig());
        return false;
    }
}

const checkExistWorkerId = async (id: any, workerId: any) => {
    const params = {
        workerId: workerId,
        userId: id
    }

    const response: Response<boolean> = await userApi.checkExistWorkerId(params);

    if (response.status === HTTP_RESPONSE_STATUS.SUCCESS) {
        return response.data;
    } else {
        toast.error(response.message, ToastDefaultConfig());
        return false;
    }
}

const defaultValue = {
    userType: USER_TYPE.WORKER,
    avatar: '',
    fullNameAr: '',
    fullNameEn: '',
    email: '',
    phone: '-1',
    workerId: '',
    firstPhoneNumber: '+966',
    nationality: '',
    password: '',
    //confirmPassword: '',
    isActive: false,
    pricePerMonth: undefined,
    firstNameAr: '',
    firstNameEn: '',
    lastNameAr: '',
    lastNameEn: '',
    regularHours: undefined,
    ramadanHours: undefined,
    cityId: undefined,
    adminId: undefined,
    serviceAreaJson: undefined,
    listServiceId: undefined,
    workerTravel: undefined,
    listWorkerSkill: [],
    listSpLinked: [],
    listCity: [],
    workerDispatchCenter: []
}

export const UpdateWorkerModal: React.FC<Props> = (props) => {
    const {
        cities, housings, teams, operationHoursAndMap, linkedDispatchers, drivers, dispatchCenters,
        busesNotLinkedDriver, skills, services, listAdmin, nationalities, workerId: Id, onHide, onUpdated, rtlMode
    } = props;
    const stepperRef = useRef<HTMLDivElement | null>(null);
    const stepper = useRef<StepperComponent | null>(null);
    const { t } = useTranslation();
    const UserSchemas = UserSchemasHelper(t)
    const [userImageUrl, setUserImageUrl] = useState("");
    const [currentSchema, setCurrentSchema] = useState<any>(UserSchemas.ACCOUNT_INFO_WORKER);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingSave, setIsLoadingSave] = useState(false);
    const [currentStep, setCurrentStep] = useState(1);
    const [initForm, setInitForm] = useState<IForm>(defaultValue);
    const [isSuccess, setIsSuccess] = useState(false);
    const [updatedUserData, setUpdatedUserData] = useState<UserModel | null>(null);
    const [isStepJump, setIsStepJump] = useState(false)
    const [nextStep, setNextStep] = useState(0)
    const [isSaveForm, setIsSaveForm] = useState(false)
    const [provincesAsCities, setProvincesAsCities] = useState<City[]>([]);
    const [originalValues, setOriginalValues] = useState<{ email?: string, phone?: string, workerId?: string }>({});
    const [storedProvincesLinkedToWorker, setStoredProvincesLinkedToWorker] = useState<number[]>([]);
    
    // Fetch provinces and convert to cities format for Geographic Coverage step
    useEffect(() => {
        userApi.getAllProvince().then(response => {
            if (response.data) {
                const converted: City[] = response.data.map((province: Province) => ({
                    id: province.id?.toString() || '',
                    nameEn: province.nameEN || '',
                    nameAr: province.nameAR || '',
                    countryId: undefined,
                    isSelected: false
                }));
                setProvincesAsCities(converted);
            }
        }).catch(error => {
            console.error('Error fetching provinces:', error);
        });
    }, []);
    
    useEffect(() => {
        if (!Id || teams.length == 0) return;

        resetData();
        setIsLoading(true);

        userApi.getUserById(Id).then(x => {
            if (x.data) {
                setUserImageUrl(x.data.personalImageUrl);
                const originalEmail = x.data.email;
                const originalPhone = x.data.phoneNumber;
                const originalWorkerId = isEmptyOrNull(x.data.workerId) || x.data.workerId === "null" ? '' : x.data.workerId;
                
                // Store original values for comparison
                setOriginalValues({
                    email: originalEmail,
                    phone: originalPhone,
                    workerId: originalWorkerId
                });
                
                // Store provincesLinkedToWorker for later use when provincesAsCities is loaded
                const provincesLinked = x.data.provincesLinkedToWorker || [];
                setStoredProvincesLinkedToWorker(provincesLinked);
                
                // Extract cityId - prefer housing's provinceId if housingId exists, otherwise use cityId from API
                let extractedCityId = '';
                
                // First, try to get provinceId from housing if housingId exists
                if (x.data.housingId && housings && housings.length > 0) {
                    const housing = housings.find((h: Housing) => h.id?.toString() === x.data.housingId?.toString());
                    if (housing && housing.provinceId) {
                        extractedCityId = housing.provinceId.toString();
                    }
                }
                
                // If not found from housing, extract from API cityId
                if (!extractedCityId && x.data.cityId) {
                    const cityIdStr = String(x.data.cityId);
                    if (cityIdStr.includes('.')) {
                        // Format is "countryId.cityId", extract the part after the dot
                        extractedCityId = cityIdStr.split('.')[1] || '';
                    } else {
                        // Use as-is, but ensure it's a string
                        extractedCityId = cityIdStr;
                    }
                }
                
                setInitForm({
                    userType: USER_TYPE.WORKER,
                    avatar: '',
                    firstNameAr: x.data.firstNameAr,
                    firstNameEn: x.data.firstNameEn,
                    lastNameAr: x.data.lastNameAr,
                    lastNameEn: x.data.lastNameEn,
                    email: originalEmail,
                    phone: originalPhone,
                    workerId: originalWorkerId,
                    firstPhoneNumber: x.data.phoneNumber.substring(0, 5) == "00966" ? '+966' : '+973',
                    nationality: isEmptyOrNull(x.data.nationality) ? '' : x.data.nationality,
                    password: x.data.password,
                    //confirmPassword: x.data.password,
                    isActive: x.data.isActive,
                    regularHours: convertOperationObjectToList(JSON.parse(x.data.operationHours || "{}")),
                    ramadanHours: convertOperationObjectToList(JSON.parse(x.data.ramadanOperationHours || "{}")),
                    cityId: extractedCityId, // AccountInfo component will override with housing's provinceId if housingId exists
                    adminId: x.data.spAdminId,
                    serviceAreaJson: !x.data.serviceArea || x.data.serviceArea == 'undefined' ? "" : x.data.serviceArea,
                    listServiceId: x.data.subSubServiceLinkeds,
                    pricePerMonth: x.data.pricePerMonth === undefined ? '' : x.data.pricePerMonth,
                    workerTravel: x.data.isTravelToDifferentCity,
                    listWorkerSkill: _fillDataUpdateForSkill(x.data.skillsLinkedToWorker),
                    listSpLinked: _fillDataUpdateSp(x.data.sPsLinkedToWoker),
                    listCity: _fillDataUpdateCity(provincesLinked),
                    workerDispatchCenter: _fillDataUpdateDispatchCenter(x.data.sPsLinkedToWoker),
                    housingId: x.data.housingId
                });
            }
        }).finally(() => setIsLoading(false));
    }, [Id, teams.length])

    // Re-initialize listCity when provincesAsCities becomes available
    // This ensures listCity is properly populated even if provincesAsCities loads after user data
    useEffect(() => {
        if (provincesAsCities.length > 0 && storedProvincesLinkedToWorker.length > 0 && Id) {
            const updatedListCity = _fillDataUpdateCity(storedProvincesLinkedToWorker);
            // Update initForm to trigger Formik re-initialization
            // Only update if listCity is empty (wasn't properly initialized initially)
            setInitForm(prevForm => {
                if (!prevForm.listCity || prevForm.listCity.length === 0) {
                    return {
                        ...prevForm,
                        listCity: updatedListCity
                    };
                }
                return prevForm;
            });
        }
    }, [provincesAsCities, storedProvincesLinkedToWorker, Id])

    useEffect(() => {
        _loadStepper();
    }, [stepperRef.current != null])

    const onSubmit = async (values: IForm) => {
        // return;
        if (Id) {
            // Validate Step 1 required fields before submitting
            if (!values.workerId || !values.workerId.toString().trim()) {
                toast.error(t('USERS_PAGE.CONTENT_STEP.VALIDATE_STEP.REQUIRE_NATIONAL_ID'), ToastDefaultConfig());
                setIsLoadingSave(false);
                return;
            }
            // Allow 0 as valid nationality (for "Other" option), but reject null, undefined, or empty string
            if (values.nationality === null || values.nationality === undefined || values.nationality === '') {
                toast.error(t('USERS_PAGE.CONTENT_STEP.VALIDATE_STEP.REQUIRE_NATIONALITY'), ToastDefaultConfig());
                setIsLoadingSave(false);
                return;
            }
            // Allow 0 as valid housingId, but reject null, undefined, or empty string
            if (values.housingId === null || values.housingId === undefined || values.housingId === '') {
                toast.error(t('USERS_PAGE.CONTENT_STEP.VALIDATE_STEP.REQUIRE_HOUSING'), ToastDefaultConfig());
                setIsLoadingSave(false);
                return;
            }
            
            // Validate services: if services are available, require at least one selection
            const hasAvailableServices = services?.majorServices?.some(item => Boolean(item?.isCentroService)) || false;
            if (hasAvailableServices && (!values.listService || values.listService.length === 0)) {
                toast.error(t('USERS_PAGE.CONTENT_STEP.VALIDATE_STEP.REQUIRE_SERVICE'), ToastDefaultConfig());
                setIsLoadingSave(false);
                return;
            }
            let serviceArea = [
                {
                    type: "POLYGON",
                    id: null,
                    geometry: [values?.serviceArea?.map(x => [x.lat, x.lng])]
                }
            ];
            let formData = new FormData();
            formData.append('Id', Id);
            formData.append('Avatar', values.avatar);
            formData.append('Email', values?.email || '');
            formData.append('Password', values?.password || '');
            formData.append(
                'PhoneNumber',
                `${values?.phone}`
            );
            formData.append('IsActive', `${values?.isActive}`);
            formData.append('UserType', `${values?.userType}`);
            formData.append('FirstNameEn', values.firstNameEn || '')
            formData.append('FirstNameAr', values.firstNameAr || '')
            formData.append('LastNameAr', values.lastNameAr || '')
            formData.append('LastNameEn', values.lastNameEn || '')
            formData.append('WorkerId', `${values?.workerId}`);
            formData.append('PricePerMonth', `${isEmptyOrNull(values?.pricePerMonth) ? '' : values?.pricePerMonth}`);
            formData.append('IsEditPermission', `${values?.isEditPermission || false}`);

            if (values.listService && values.listService?.length > 0) {
                values.listService?.forEach((data: ServiceTreeNode) =>
                    formData.append('SubSubServiceLinkeds', `${data.subSubId}`)
                )
            }

            if (values.listWorkerSkill && values.listWorkerSkill?.length > 0) {
                values.listWorkerSkill?.forEach((data: Skill) =>
                    formData.append('WorkerSkills', `${data.id}`)
                )
            }

            if (values.listCity && values.listCity?.length > 0) {
                values.listCity?.forEach((data: SelectFilter) => formData.append('ProvinceLinkeds', `${data.value}`))
            }

            if (values.listSpLinked && values.listSpLinked?.length > 0) {
                values.listSpLinked?.forEach((data: SelectFilter) => formData.append('SpLinkeds', `${data.value}`))
            }
            formData.append('IsAllowTravel', `${values?.workerTravel || false}`);
            formData.append('NationalityId', `${isEmptyOrNull(values?.nationality) ? '' : values?.nationality}`);
            formData.append('CityId', `${values?.cityId || ''}`);
            formData.append('IsRemoveAvatar', `${values?.isRemoveAvatar ? "true" : "false"}`);
            if (values.housingId) {
              formData.append('HousingId', `${values.housingId}`);
            }

            const resp = await userApi.updateWorker(formData).finally(() => setIsLoadingSave(false));
            if (resp.status === HTTP_RESPONSE_STATUS.SUCCESS) {
                stepper?.current?.goto(4);
                setCurrentStep(4)
                setIsSuccess(true);
                setUpdatedUserData(resp.data);
            } else {
                toast.error(resp.message, ToastDefaultConfig());
            }
        }

    }

    const _loadStepper = () => {
        stepper.current = StepperComponent.createInstance(stepperRef.current as HTMLDivElement)
    }

    const onPrevStep = async (setErrors: any, validateForm?: any) => {
        if (!stepper.current) {
            return
        }
        setErrors({});
        setIsSuccess(false);
        stepper.current.goPrev();

        switch (stepper?.current?.currentStepIndex) {
            case 1:
                setCurrentSchema(UserSchemas.ACCOUNT_INFO_WORKER);
                break
            case 2:
                setCurrentSchema(UserSchemas.WORK_INFO.WORKER)
                break
            case 3:
                setCurrentSchema(UserSchemas.WORK_LOCATION.WORKER)
                break
        }
        setCurrentStep(currentStep - 1);
        
        // Revalidate the form after schema change
        if (validateForm) {
            setTimeout(() => {
                validateForm();
            }, 100);
        }
    }
    const handleSubmit = async (values: UserFormModel) => {
        setIsLoading(false)
        setIsLoadingSave(true)
        return await onSubmit(values)
    }
    const onNextStep = async (values: IForm, formikHelpers: FormikHelpers<IForm>) => {
        if (!stepper.current || isLoading) {
            return
        }
        setIsLoading(true)

        switch (currentStep) {
            case 1:
                // Extract local phone number for validation (remove country code if present)
                let phoneToValidate = values.phone || '';
                // If phone starts with country code, extract just the local part
                if (phoneToValidate.startsWith('00966')) {
                    phoneToValidate = phoneToValidate.substring(5); // Remove '00966' prefix
                } else if (phoneToValidate.startsWith('00973')) {
                    phoneToValidate = phoneToValidate.substring(5); // Remove '00973' prefix
                } else if (phoneToValidate.startsWith('+966')) {
                    phoneToValidate = phoneToValidate.substring(4); // Remove '+966' prefix
                } else if (phoneToValidate.startsWith('+973')) {
                    phoneToValidate = phoneToValidate.substring(4); // Remove '+973' prefix
                }
                
                // Validate phone number format
                if (!checkValidPhoneNumber(values.firstPhoneNumber || '', phoneToValidate)) {
                    formikHelpers.setFieldError("phone", t('USERS_PAGE.CONTENT_STEP.VALIDATE_STEP.VALIDATE_PHONE'));
                    setIsLoading(false)
                    return;
                }

                // Only check existence if values have changed from original
                if (values?.email && values.email !== originalValues.email && await checkExistEmail(Id, values?.email)) {
                    toast.error(t('USERS_PAGE.CONTENT_STEP.VALIDATE_STEP.EMAIL_EXIST'), ToastDefaultConfig());
                    setIsLoading(false)
                    return;
                }

                if (values.phone !== originalValues.phone && await checkExistPhone(Id, values.phone)) {
                    toast.error(t('USERS_PAGE.CONTENT_STEP.VALIDATE_STEP.PHONE_EXIST'), ToastDefaultConfig());
                    setIsLoading(false)
                    return;
                }

                if (values.workerId && values.workerId !== originalValues.workerId && await checkExistWorkerId(Id, values.workerId)) {
                    toast.error(t('USERS_PAGE.CONTENT_STEP.VALIDATE_STEP.NATIONAL_ID_EXIST'), ToastDefaultConfig());
                    setIsLoading(false)
                    return;
                }

                if (values?.email && values.email !== originalValues.email && await checkExistUserInfo(Id, `${values?.phone}`, values?.email)) {
                    toast.error(t('USERS_PAGE.CONTENT_STEP.VALIDATE_STEP.USER_HAS_EXIST'), ToastDefaultConfig());
                    setIsLoading(false)
                    return;
                }

                formikHelpers.setTouched({})
                setCurrentSchema(UserSchemas.WORK_INFO.WORKER)
                if (isSaveForm) await handleSubmit(values)
                else stepper?.current?.goNext()
                break;
            case 2:
                // Validate services: if services are available, require at least one selection
                const hasAvailableServices = services?.majorServices?.some(item => Boolean(item?.isCentroService)) || false;
                if (hasAvailableServices && (!values.listService || values.listService.length === 0)) {
                    formikHelpers.setFieldError("listService", t('USERS_PAGE.CONTENT_STEP.VALIDATE_STEP.REQUIRE_SERVICE'));
                    toast.error(t('USERS_PAGE.CONTENT_STEP.VALIDATE_STEP.REQUIRE_SERVICE'), ToastDefaultConfig());
                    setIsLoading(false);
                    return;
                }
                formikHelpers.setTouched({})
                setCurrentSchema(UserSchemas.WORK_LOCATION.WORKER)
                if (isSaveForm) await handleSubmit(values)
                else stepper?.current?.goNext()
                break;
            case 3:

                if (values.workerTravel && (!values.listCity || !values.listCity.length)) {
                    formikHelpers.setFieldError("listCity", t('USERS_PAGE.CONTENT_STEP.VALIDATE_STEP.REQUIRE_CITIES'));
                    return;
                }

                if (isSaveForm) await handleSubmit(values)
                else stepper?.current?.goNext()
                break;
            case 4:
                onHideModal();
                break;
        }
        if (!isSaveForm) {
            setCurrentStep(currentStep + 1);
        }

        setIsLoading(false)
    }
    const onStepJump = async (values: IForm, formikHelpers: FormikHelpers<IForm>) => {
        console.log(nextStep)
        if (!stepper.current || isLoading) {
            return
        }
        setIsLoading(true)
        switch (currentStep) {
            case 1:
                // Extract local phone number for validation (remove country code if present)
                let phoneToValidateJump = values.phone || '';
                // If phone starts with country code, extract just the local part
                if (phoneToValidateJump.startsWith('00966')) {
                    phoneToValidateJump = phoneToValidateJump.substring(5); // Remove '00966' prefix
                } else if (phoneToValidateJump.startsWith('00973')) {
                    phoneToValidateJump = phoneToValidateJump.substring(5); // Remove '00973' prefix
                } else if (phoneToValidateJump.startsWith('+966')) {
                    phoneToValidateJump = phoneToValidateJump.substring(4); // Remove '+966' prefix
                } else if (phoneToValidateJump.startsWith('+973')) {
                    phoneToValidateJump = phoneToValidateJump.substring(4); // Remove '+973' prefix
                }
                
                // Validate phone number format
                if (!checkValidPhoneNumber(values.firstPhoneNumber || '', phoneToValidateJump)) {
                    formikHelpers.setFieldError("phone", t('USERS_PAGE.CONTENT_STEP.VALIDATE_STEP.VALIDATE_PHONE'));
                    setIsLoading(false)
                    return;
                }

                // Only check existence if values have changed from original
                if (values?.email && values.email !== originalValues.email && await checkExistEmail(Id, values?.email)) {
                    toast.error(t('USERS_PAGE.CONTENT_STEP.VALIDATE_STEP.EMAIL_EXIST'), ToastDefaultConfig());
                    setIsLoading(false)
                    return;
                }

                if (values.phone !== originalValues.phone && await checkExistPhone(Id, values.phone)) {
                    toast.error(t('USERS_PAGE.CONTENT_STEP.VALIDATE_STEP.PHONE_EXIST'), ToastDefaultConfig());
                    setIsLoading(false)
                    return;
                }

                if (values.workerId && values.workerId !== originalValues.workerId && await checkExistWorkerId(Id, values.workerId)) {
                    toast.error(t('USERS_PAGE.CONTENT_STEP.VALIDATE_STEP.NATIONAL_ID_EXIST'), ToastDefaultConfig());
                    setIsLoading(false)
                    return;
                }

                if (values?.email && values.email !== originalValues.email && await checkExistUserInfo(Id, `${values?.phone}`, values?.email)) {
                    toast.error(t('USERS_PAGE.CONTENT_STEP.VALIDATE_STEP.USER_HAS_EXIST'), ToastDefaultConfig());
                    setIsLoading(false)
                    return;
                }

                formikHelpers.setTouched({})
                setCurrentSchema(UserSchemas.WORK_INFO.WORKER)
                if (isSaveForm) await handleSubmit(values)
                else stepper?.current?.goto(nextStep);
                break;
            case 2:
                // Validate services: if services are available, require at least one selection
                const hasAvailableServicesJump = services?.majorServices?.some(item => Boolean(item?.isCentroService)) || false;
                if (hasAvailableServicesJump && (!values.listService || values.listService.length === 0)) {
                    formikHelpers.setFieldError("listService", t('USERS_PAGE.CONTENT_STEP.VALIDATE_STEP.REQUIRE_SERVICE'));
                    toast.error(t('USERS_PAGE.CONTENT_STEP.VALIDATE_STEP.REQUIRE_SERVICE'), ToastDefaultConfig());
                    setIsLoading(false);
                    return;
                }
                formikHelpers.setTouched({})
                setCurrentSchema(UserSchemas.WORK_LOCATION.WORKER)
                if (isSaveForm) await handleSubmit(values)
                else stepper?.current?.goto(nextStep);
                break;
            case 3:
                if (values.workerTravel && (!values.listCity || !values.listCity.length)) {
                    formikHelpers.setFieldError("listCity", t('USERS_PAGE.CONTENT_STEP.VALIDATE_STEP.REQUIRE_CITIES'));
                }
                if (isSaveForm) await handleSubmit(values)
                else stepper?.current?.goto(nextStep);
                break;
            case 4:
                onHideModal();
                break;
        }
        if (!isSaveForm) {
            setCurrentStep(nextStep);
        }
        setIsLoading(false)
    }
    const _fillDataUpdateForSkill = (listIdSelect: number[]) => {

        let listWorkerSkill: Skill[] = [];
        skills.map((item: Skill) => {
            const itemExist = listIdSelect.includes(Number(item.id) || 0);
            return itemExist ? listWorkerSkill.push(item) : ''
        })
        console.log(listWorkerSkill)
        return listWorkerSkill;
    }

    const _fillDataUpdateSp = (listId: string[]) => {
        // let listSp: SelectFilter[] = [];
        // let groupSpInfo: SPInfos[] = [];
        // dispatchCenters.map((item: DispatchCenter) => groupSpInfo = _.concat(groupSpInfo, item.spInfos));
        // groupSpInfo.map((g: SPInfos) => {
        //     const itemExist = listId.includes(g.spId);
        //     return itemExist ? listSp.push({ label: rtlMode ? g.fullNameAr : g.fullNameEn, value: g.spId }) : '';
        // })
        // return listSp;
        return listId.map(e => teams.find(e1 => e1.id == e)).filter((e): e is typeof teams[0] => e != undefined).map(e => ({ label: rtlMode ? e.fullNameAr : e.fullNameEn, value: e.id }));
    }

    const _fillDataUpdateCity = (listId: number[]) => {
        let listCity: SelectFilter[] = [];
        
        if (provincesAsCities.length > 0) {
            provincesAsCities.forEach((province: City) => {
                // Check if the province ID matches any of the city IDs from API
                const itemExist = listId.includes(Number(province.id));
                if (itemExist) {
                    listCity.push({ 
                        label: rtlMode ? province.nameAr : province.nameEn, 
                        value: province.id 
                    });
                }
            });
        }
        
        return listCity;
    }

    const _fillDataUpdateDispatchCenter = (listId: string[]) => {
        let listSelect: SelectFilter[] = [];
        dispatchCenters.forEach((item: DispatchCenter) => {
            item.spInfos.map((g: SPInfos) => {
                const itemExist = listId.includes(g.spId);
                return itemExist ? listSelect.push({ label: item.name, value: item.id }) : '';
            })
        })
        return listSelect;
    }

    const onHideModal = () => {
        // If we have updated data, call onUpdated before closing
        if (updatedUserData) {
            onUpdated?.(updatedUserData);
        }
        resetData();
        onHide?.();
    };

    const resetData = () => {
        setCurrentStep(1);
        stepper?.current?.goto(1);
        setCurrentSchema(UserSchemas.ACCOUNT_INFO_WORKER);
        setIsSuccess(false);
        setUpdatedUserData(null);
        setInitForm(defaultValue);
        setOriginalValues({});
    }

    return (
        <>
            <Modal show={!!Id} onHide={onHideModal} backdrop="static" keyboard={false} size='xl' className='create-user-modal'>
                {!isSuccess &&
                    <Modal.Header closeButton className='header-primary'>
                        <Modal.Title className='fw-normal'>{t('USERS_PAGE.STEP_UPDATE_USER.TITLE_WORKER')}</Modal.Title>
                    </Modal.Header>
                }
                <Formik
                    key={Id} 
                    validationSchema={currentSchema}
                    initialValues={initForm}
                    onSubmit={(values, helpers) => { isStepJump ? onStepJump(values, helpers) : onNextStep(values, helpers) }}
                    initialTouched={{}}
                    enableReinitialize
                >
                    {(props) => {
                        const { handleSubmit, errors, touched, setTouched, setErrors, isValid, values, setFieldError, setFieldValue } = props;
                        // console.log(errors, touched, values)
                        return (
                            <>
                                {(isLoading && initForm.phone == '-1') && <div className='update-loading mt-10 mb-10'>
                                    <div className='spinner-border' role='status'></div>
                                </div>}
                                {initForm.phone != '-1' &&
                                    <div
                                        ref={stepperRef}
                                        className='stepper stepper-links d-flex flex-column'
                                        id='kt_create_account_stepper'
                                    >
                                        <form id='kt_create_account_form'>
                                            <Modal.Body>
                                                {isSuccess ? (
                                                    <Row className='justify-content-center'>
                                                        <Col sm="12" md="11">
                                                            <Completed onClose={onHideModal} />
                                                        </Col>
                                                    </Row>
                                                ) : (
                                                    <>
                                                        <StepByStepTechUserHeader values={values} handleStepJump={(step) => { handleSubmit(); setIsStepJump(true); setNextStep(step); setIsSaveForm(false) }} currentStep={currentStep} />
                                                        <Row className='justify-content-center'>
                                                            <Col sm="12" md="11">
                                                                <div className='current' data-kt-stepper-element='content'>
                                                                    {nationalities && cities && (
                                                                        <AccountInfo
                                                                            key={Id}
                                                                            errors={errors}
                                                                            values={values}
                                                                            touched={touched}
                                                                            rtl={rtlMode}
                                                                            nationalities={nationalities}
                                                                            cities={cities}
                                                                            housings={housings}
                                                                            setFieldValue={setFieldValue}
                                                                            setFieldError={setFieldError}
                                                                            setTouched={setTouched}
                                                                            avatar={userImageUrl}
                                                                            clearAvatar={() => setUserImageUrl("")}
                                                                        />
                                                                    )}
                                                                </div>

                                                                <div data-kt-stepper-element='content'>
                                                                    <WorkInfo
                                                                        errors={errors}
                                                                        values={values}
                                                                        touched={touched}
                                                                        rtl={rtlMode}
                                                                        skills={skills}
                                                                        services={services}
                                                                        busesNotLinkedDriver={busesNotLinkedDriver}
                                                                        dispatchCenters={dispatchCenters}
                                                                        drivers={drivers}
                                                                        linkedDispatchers={linkedDispatchers}
                                                                        currentCheckCustomStep={stepper.current?.currentStepIndex || 1}
                                                                        setFieldValue={setFieldValue}
                                                                        setTouched={setTouched}
                                                                        step={stepper.current?.currentStepIndex}
                                                                        listAdmin={listAdmin}
                                                                        techId={Id}
                                                                        isUpdateForm={true}
                                                                    />
                                                                </div>
                                                                <div data-kt-stepper-element='content'>
                                                                    <WorkLocation
                                                                        errors={errors}
                                                                        values={values}
                                                                        touched={touched}
                                                                        rtl={rtlMode}
                                                                        teams={teams}
                                                                        cities={provincesAsCities.length > 0 ? provincesAsCities : cities}
                                                                        currentCheckCustomStep={stepper.current?.currentStepIndex || 1}
                                                                        setFieldValue={setFieldValue}
                                                                        setTouched={setTouched}
                                                                        step={stepper.current?.currentStepIndex}
                                                                        operationHoursAndMap={operationHoursAndMap}
                                                                        dispatchCenters={dispatchCenters}
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </>
                                                )}
                                            </Modal.Body>
                                            {!isSuccess && (
                                                <Modal.Footer className='d-flex flex-stack p-5 assign-footer'>
                                                    <div className='mr-2'>
                                                        {
                                                            stepper?.current?.currentStepIndex === 1 ?
                                                                <button
                                                                    onClick={onHideModal}
                                                                    type='button'
                                                                    className='btn btn-secondary w-150px me-3 btn-back'>
                                                                    {t('BACK')}
                                                                </button>
                                                                :
                                                                <button
                                                                    onClick={() => { onPrevStep(setErrors, props.validateForm); setIsStepJump(false) }}
                                                                    type='button'
                                                                    className='btn btn-secondary w-150px me-3 btn-back'
                                                                    data-kt-stepper-action='previous'
                                                                >
                                                                    {t('BACK')}
                                                                </button>
                                                        }
                                                    </div>
                                                    <div>
                                                        {!(stepper?.current?.currentStepIndex && stepper.current.currentStepIndex === 3) && <button type='button' onClick={() => { handleSubmit(); setIsStepJump(false); setIsSaveForm(false) }} className='btn btn-secondary w-150px me-3 btn-back' disabled={isLoading || isLoadingSave || !isValid}>
                                                            {isLoading && <div className='spinner-border spinner-border-sm me-2' role='status' aria-hidden='true'></div>}
                                                            <span className='indicator-label'>  {t('NEXT')}</span>
                                                        </button>}
                                                        <button type='button' onClick={() => { handleSubmit(); setIsSaveForm(true) }} className='btn btn-dark w-150px me-3' disabled={isLoadingSave || isLoading || !isValid}>
                                                            {isLoadingSave && <div className='spinner-border spinner-border-sm me-2' role='status' aria-hidden='true'></div>}
                                                            <span className='indicator-label'>  {t('USERS_PAGE.SAVE')}</span>
                                                        </button>
                                                    </div>
                                                </Modal.Footer>
                                            )}
                                        </form>
                                    </div>
                                }
                            </>
                        )
                    }}
                </Formik>
            </Modal>
        </>
    )
}